import GetCode from './GetCode';

export default GetCode;
